import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { Environment } from "./environments/environment";

// Static bootstrap fallback. Keep it literal: this bypasses Angular sanitization.
const SERVER_ERROR_HTML = `
  <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;
              font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;
              text-align:center;padding:2rem;color:#2d3648;">
    <div style="max-width:32rem;">
      <h1 style="font-size:1.5rem;margin-bottom:.75rem;">Il servizio non è al momento disponibile</h1>
      <p style="margin-bottom:1.5rem;line-height:1.5;">
        Si è verificato un problema durante la connessione ai nostri server.
        Riprova tra qualche minuto.
      </p>
      <p style="color:#6b7280;font-size:.9rem;">The service is temporarily unavailable. Please try again later.</p>
    </div>
  </div>
`;

Environment.load().then(() => {
  bootstrapApplication(AppComponent, {
    ...appConfig,
  }).catch((err) => {
    console.error(err);
    document.body.innerHTML = SERVER_ERROR_HTML;
  });
});
